/* ALOLA Motor de regalos · ejecutor (fase 1, spec v1.3). Versión 11-oct: códigos viejos de AOV + "Agregando tu regalo…" en Pagar.
   16-oct: botón "Cambiar al pack" de la franja «Cámbialo al pack».
   Liquid (snippets/alola-regalos.liquid) deja un plan en JSON dentro de <alola-regalos>;
   aquí solo se ejecuta: quitar líneas, ajustar regalos a 1 unidad, agregar regalos con la
   propiedad _regalo y aplicar el código nativo sin pisar los cupones de la clienta.
   Después se vuelve a renderizar el carrito (cajón y /cart) y el nuevo plan debe quedar vacío.
   Guardas: una corrida a la vez, máximo 4 corridas por 15 s (contra bucles), y nunca toca
   líneas de AOV (_aovCampId) ni productos que no sean regalo. */
(function () {
  if (customElements.get('alola-regalos')) return;
  var H = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: H, body: JSON.stringify(body) });
  }
  function st() {
    var w = window;
    w.__alolaRegalos = w.__alolaRegalos || { busy: false, n: 0, t: 0, codigoFallido: '' };
    return w.__alolaRegalos;
  }
  // (11-oct) Códigos que AOV dejaba en el carrito. Con AOV fuera de la web ya no aplican a nada, pero siguen guardados en
  // los carritos armados antes del 10-oct y ocupan lugar: Shopify acepta máximo 5 códigos por carrito.
  var AOV = /^(AOVAI_|REGALO_GRATIS_TiempoLimitado$|Regalo_Por_Tiempo_Limitado$|washbag_portiempolimitado$|TrussGWP_TIEMPO_LIMITADO$)/i;

  // (11-oct, pedido de Ana) Mientras el motor agrega el regalo, el botón de pagar lo dice. Si la clienta toca "Pagar pedido"
  // en ese momento, se espera a que termine (máx. ~6 s) y recién se va al pago.
  function marcarPago(txt) {
    document.querySelectorAll('button[name="checkout"]').forEach(function (b) {
      var sp = b.querySelector('span') || b;
      if (txt) {
        if (b.dataset.alolaTxt == null) b.dataset.alolaTxt = sp.textContent;
        sp.textContent = txt; b.setAttribute('aria-busy', 'true'); b.style.opacity = '.75'; b.style.cursor = 'progress';
      } else if (b.dataset.alolaTxt != null) {
        sp.textContent = b.dataset.alolaTxt; delete b.dataset.alolaTxt;
        b.removeAttribute('aria-busy'); b.style.opacity = ''; b.style.cursor = '';
      }
    });
  }

  // Ejecuta un plan (quitar, ajustar, agregar, código). Lo usan el cajón/carrito y "Comprar ahora".
  async function correr(plan) {
    var s = st(), now = Date.now();
    if (now - s.t > 15000) { s.n = 0; s.t = now; }
    if (s.sinRegalos) { plan.agregar = []; }        // (10-oct) el código no se pudo aplicar: no se agregan regalos que se cobrarían
    var codigo = plan.codigo && plan.codigo !== s.codigoFallido && !s.sinRegalos ? plan.codigo : '';
    var hay = (plan.quitar && plan.quitar.length) || (plan.agregar && plan.agregar.length) ||
              (plan.ajustar && plan.ajustar.length) || codigo;
    if (!hay || s.busy || s.n >= 4) return { cambio: false, avisos: [] };
    s.busy = true; s.n++;
    if ((plan.agregar && plan.agregar.length) || codigo) marcarPago('Agregando tu regalo…');
    var avisos = [], cambio = false, r;
    try {
      for (var q of plan.quitar || []) {
        r = await post('/cart/change.js', { id: q.key, quantity: 0 });
        if (r.ok) { cambio = true; if (q.msg && q.tipo === 'comprado') avisos.push(q.msg); }   // (10-oct) lo demás lo dice el bloque fijo
      }
      for (var a of plan.ajustar || []) {
        r = await post('/cart/change.js', { id: a.key, quantity: 1 });
        if (r.ok) cambio = true;
      }
      for (var g of plan.agregar || []) {
        r = await post('/cart/add.js', { items: [{ id: g.id, quantity: 1, properties: { _regalo: g.camp } }] });
        if (r.ok) cambio = true;   // (10-oct) sin aviso flotante: el bloque "Tus regalos y sorteos" lo muestra
      }
      if (codigo) {
        var cart = await (await fetch('/cart.js', { headers: { 'Accept': 'application/json' } })).json();
        var lista = cart.discount_codes || [], C = codigo.toUpperCase();
        var nuestro = lista.filter(function (d) { return d.code.toUpperCase() === C; })[0];
        var hayRegalo = (cart.items || []).some(function (i) { return i.properties && i.properties._regalo; });
        if (hayRegalo && (!nuestro || nuestro.applicable === false)) {
          // (11-oct) Si el carrito ya tenía 5 códigos (los de AOV), el nuestro entraba 6.º, Shopify lo rechazaba y el regalo
          // se retiraba: 3 pedidos Kérastase sin regalo el 10 y 11-oct. Se sueltan primero los de AOV que no aplican y, si
          // igual no hay lugar, cualquier otro que no aplique a nada. Los cupones que sí aplican nunca se tocan.
          var otros = lista.filter(function (d) {
            return d.code.toUpperCase() !== C && !(d.applicable === false && AOV.test(d.code));
          });
          if (otros.length > 4) otros = otros.filter(function (d) { return d.applicable !== false; });
          var codes = otros.map(function (d) { return d.code; }).concat(codigo);
          r = await post('/cart/update.js', { discount: codes.join(',') });
          if (r.ok) {
            var est = await r.json();
            var ok = (est.discount_codes || []).some(function (d) { return d.code.toUpperCase() === C && d.applicable !== false; });
            if (ok) cambio = true; else s.codigoFallido = codigo;   // no insistir si Shopify no lo acepta
          }
        } else if (nuestro && nuestro.applicable !== false) {
          s.codigoFallido = codigo;   // ya estaba aplicado (aunque Liquid no lo vea): no repetir
        }
        // (10-oct, auditoría) nunca dejar un regalo COBRADO: si después del código alguna línea _regalo sigue con precio, se retira
        if (s.codigoFallido === codigo) {
          var c2 = await (await fetch('/cart.js', { headers: { 'Accept': 'application/json' } })).json();
          for (var it of (c2.items || [])) {
            if (it.properties && it.properties._regalo && it.final_line_price > 0) {
              r = await post('/cart/change.js', { id: it.key, quantity: 0 });
              if (r.ok) { cambio = true; s.sinRegalos = true; avisos.push(it.product_title + ' no pudo quedar gratis y lo retiramos de tu carrito.'); }
            }
          }
        }
      }
    } catch (e) { /* red caída: el próximo render lo reintenta */ }
    s.busy = false;
    if (!s.esperandoPago) marcarPago('');
    return { cambio: cambio, avisos: avisos };
  }

  // Si la clienta toca "Pagar pedido" mientras el motor trabaja, se espera a que termine, se revisa el carrito una vez más
  // (como "Comprar ahora") y recién se sigue al pago. Cualquier falla o demora larga sigue al pago igual: nunca se traba.
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button[name="checkout"]');
    if (!b) return;
    if (b.dataset.alolaPasa) { delete b.dataset.alolaPasa; return; }
    var s = st();
    if (!s.busy || s.esperandoPago) { if (s.esperandoPago) e.preventDefault(); return; }
    e.preventDefault(); e.stopPropagation();
    esperarYPagar(b);
  }, true);
  function pausa(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  async function esperarYPagar(b) {
    var s = st(), t0 = Date.now(), enCajon = !!b.closest('#Cart-Drawer');
    s.esperandoPago = true;
    marcarPago('Agregando tu regalo…');
    async function revisar() {
      while (s.busy && Date.now() - t0 < 6000) await pausa(150);
      if (!s.busy) {
        s.n = 0; s.t = Date.now();
        var plan = await planActual();
        if (plan) await correr(plan);
        while (s.busy && Date.now() - t0 < 8000) await pausa(150);   // otra corrida (re-render del cajón) a medias
      }
    }
    // (auditoría 11-oct) tope total de 9 s aunque una petición se cuelgue en la red: nunca trabar el pago
    try { await Promise.race([revisar(), pausa(9000)]); } catch (e) { /* sigue al pago igual */ }
    s.esperandoPago = false;
    marcarPago('');
    var nb = b.isConnected ? b : document.querySelector(enCajon ? '#Cart-Drawer button[name="checkout"]' : 'button[name="checkout"]');
    if (nb) {
      // (auditoría 11-oct) en /cart el form manda cantidades por posición; si el motor acaba de cambiar las líneas y la página
      // aún no se re-pintó, irían cantidades viejas. Las cantidades ya se guardan solas al cambiarlas, así que no se mandan.
      if (!enCajon && nb.form) [].forEach.call(nb.form.elements, function (i) { if (i.name === 'updates[]') i.disabled = true; });
      nb.dataset.alolaPasa = '1'; nb.click();
    } else { location.href = '/checkout'; }
  }

  // --- "Comprar ahora" propio (9-oct-2026) ---------------------------------------------
  // El botón nativo de Shopify arma un checkout aparte y salta el carrito, así que ni AOV ni el
  // motor llegan a poner el regalo. Este botón agrega el producto al carrito, pide el plan del
  // motor (render de la sección main-cart), lo ejecuta y recién va al checkout. Si algo falla en
  // el camino, va al checkout igual: nunca peor que el botón nativo.
  async function planActual() {
    // OJO: /cart con Accept: application/json devuelve el cart.js, no la sección. Por eso section_id (HTML).
    var r = await fetch('/cart?section_id=main-cart');
    var doc = new DOMParser().parseFromString(await r.text(), 'text/html');
    var s = doc.querySelector('alola-regalos script[type="application/json"]');
    if (!s) return null;
    try { return JSON.parse(s.textContent); } catch (e) { return null; }
  }
  function datosForm(form) {
    var fd = new FormData(form), props = {}, id = fd.get('id');
    var qty = parseInt(fd.get('quantity') || '1', 10) || 1;
    if (!id) { var i = form.querySelector('input[name="id"]'); id = i && i.value; }
    fd.forEach(function (v, k) { var m = /^properties\[(.+)\]$/.exec(k); if (m && v !== '') props[m[1]] = v; });
    var item = { id: parseInt(id, 10), quantity: qty };
    if (Object.keys(props).length) item.properties = props;
    return item;
  }
  function mostrarError(form, msg) {
    var pf = form.closest('product-form'), w = pf && pf.querySelector('.product-form__error-message-wrapper');
    if (!w) { alert(msg); return; }
    var t = w.querySelector('.product-form__error-message'); if (t) t.textContent = msg;
    w.hidden = false;
    setTimeout(function () { w.hidden = true; }, 6000);
  }
  async function comprarAhora(btn) {
    var form = btn.closest('form') || document.getElementById(btn.getAttribute('form') || '');
    if (!form || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true');
    var item = datosForm(form);
    try {
      var r = await post('/cart/add.js', { items: [item] });
      if (!r.ok) {
        var err = {}; try { err = await r.json(); } catch (e) {}
        mostrarError(form, err.description || err.message || 'No se pudo agregar el producto.');
        btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy');
        return;
      }
      var s = st(); s.n = 0; s.t = Date.now(); s.busy = false;
      for (var i = 0; i < 2; i++) {               // 1.ª pasada agrega regalo + código; la 2.ª confirma que no quede nada
        var plan = await planActual();
        if (!plan) break;
        var res = await correr(plan);
        if (!res.cambio) break;
      }
    } catch (e) { /* va al checkout igual */ }
    location.href = '/checkout';
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-alola-comprar-ahora]');
    if (!b) return;
    e.preventDefault();
    comprarAhora(b);
  });

  // Vuelve a pintar el cajón (evento del tema) y /cart (sección main-cart). Al reconectarse <alola-regalos>
  // corre el plan nuevo: si con lo agregado ya califica, entra el regalo y el código.
  function refrescarCarrito() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    var form = document.querySelector('#Cart .thb-cart-form');
    if (form) {
      fetch(location.pathname + '?section_id=main-cart')   // (9-oct) con Accept JSON, /cart devolvía el cart.js
        .then(function (r) { return r.text(); })
        .then(function (h) {
          var d = new DOMParser().parseFromString(h, 'text/html').querySelector('.thb-cart-form');
          if (d) form.innerHTML = d.innerHTML;
        }).catch(function () {});
    }
  }

  // --- "+ Agregar" en "Te falta 1…" (10-oct-2026) -------------------------------------------
  // Agrega 1 unidad del producto sugerido (el más vendido de la marca que falta) sin salir del carrito.
  document.addEventListener('click', async function (e) {
    var b = e.target.closest && e.target.closest('[data-alola-rys-add]');
    if (!b) return;
    e.preventDefault();
    if (b.classList.contains('is-loading')) return;
    var txt = b.textContent;
    b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); b.textContent = 'Agregando…';
    try {
      // (21-oct) _origen: marca oculta de la línea para medir en el pedido cuánto vende el "+ Agregar" del aviso
      var org = (b.closest('.is-promo') ? 'aviso-2do-' : 'aviso-regalo-') + (b.closest('#Cart-Drawer, cart-drawer') ? 'cajon' : 'carrito');
      var avid = parseInt(b.getAttribute('data-alola-rys-add'), 10);
      // (24-oct) si ya está en el carrito, mismas propiedades que esa línea (no se parte en 2 filas)
      var aprops = window.alolaPropsLinea ? await window.alolaPropsLinea(avid, org) : { _origen: org };
      var r = await post('/cart/add.js', { items: [{ id: avid, quantity: 1, properties: aprops }] });
      if (!r.ok) throw new Error('add');
      var s = st(); s.n = 0; s.t = Date.now();   // el plan siguiente puede agregar el regalo
      refrescarCarrito();
    } catch (err) {
      b.textContent = 'No se pudo agregar';
      setTimeout(function () { b.textContent = txt; b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); }, 2500);
    }
  });

  // --- "Cambiar al pack" (16-oct-2026, Ana) ----------------------------------------------------
  // La franja .alola-pack (snippets/alola-regalos.liquid) sale cuando el carrito tiene todos los sueltos de un pack que cuesta
  // menos. Agrega el pack (add.js valida el stock) y después baja los sueltos (update.js por clave de línea).
  // Mide en GA4 (select_item, lista 'Aviso cambia al pack', mismo item_id del píxel → atribuye el agregado y la compra) y Clarity.
  function medirPack(b, d) {
    try {
      // (17-oct) 'Aviso agrega en pack' = faltaba uno de los sueltos (modo suma)
      var lista = d.modo === 'suma' ? 'Aviso agrega en pack' : 'Aviso cambia al pack';
      var id = (b.closest('#Cart-Drawer, cart-drawer') ? 'cajon' : 'carrito') + ':cambiar';
      var item = { item_id: 'shopify_PE_' + d.pid + '_' + d.pack, item_name: d.nom, item_list_name: lista, item_list_id: id };
      var datos = { send_to: 'G-EQPN9YQH7D', item_list_name: lista, item_list_id: id, items: [item] };
      window.dataLayer = window.dataLayer || [];
      if (typeof window.gtag === 'function') window.gtag('event', 'select_item', datos);
      else (function () { window.dataLayer.push(arguments); })('event', 'select_item', datos);
      if (typeof window.clarity === 'function') window.clarity('event', d.modo === 'suma' ? 'suma_pack' : 'cambia_pack');
    } catch (x) {}
  }
  // (17-oct, Ana) después del cambio, aviso corto (la franja solo desaparecía). Mismo look que el aviso de regalos, con estilos
  // propios en línea porque el CSS de .alola-regalos__toast solo se pinta cuando el carrito muestra regalos o el 2do con X.
  function listoPack() {
    try {
      var old = document.querySelector('.alola-regalos__toast'); if (old) old.remove();
      var t = document.createElement('div'); t.className = 'alola-regalos__toast'; t.setAttribute('role', 'status');
      t.textContent = 'Listo: ahora llevas el pack';
      t.style.cssText = 'position:fixed;bottom:14px;z-index:99999;background:#1a1c1d;color:#fff;border-radius:12px;padding:10px 14px;font-size:13px;line-height:1.4;box-shadow:0 6px 24px rgba(0,0,0,.25);' +
        (window.innerWidth >= 768 ? 'right:24px;left:auto;max-width:360px;' : 'left:12px;right:12px;');
      document.body.appendChild(t);
      setTimeout(function () { t.remove(); }, 3500);
    } catch (x) {}
  }
  document.addEventListener('click', async function (e) {
    var b = e.target.closest && e.target.closest('[data-alola-pack]');
    // (22-oct, Ana) toda la franja vale como el botón (menos la nota legal): en Clarity se tocaba el texto y no pasaba nada
    var fr = !b && e.target.closest && e.target.closest('.alola-pack');
    if (fr && !e.target.closest('.alola-pack__n')) {
      b = fr.querySelector('[data-alola-pack]');
      if (b && typeof window.clarity === 'function') window.clarity('event', 'pack_toque_franja');
    }
    if (!b) return;
    e.preventDefault();
    if (b.classList.contains('is-loading')) return;
    var d;
    try { d = JSON.parse(b.getAttribute('data-alola-pack')); } catch (x) { return; }
    var txt = b.textContent;
    var suma = d.modo === 'suma';
    b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); b.textContent = suma ? 'Agregando…' : 'Cambiando…';
    // (17-oct, auditoría Fable E2) /cart/update.js NO valida stock (agrega aunque no haya), así que va en 2 pasos:
    // 1) /cart/add.js del pack (este sí valida: si no hay stock responde 422 y puede haber agregado solo una parte → se deshace);
    // 2) /cart/update.js de los sueltos por clave de línea (las claves no cambian al agregar el pack). Si el paso 2 falla,
    // se saca el pack agregado para que el carrito quede como estaba.
    async function carrito() { return (await fetch('/cart.js', { headers: { 'Accept': 'application/json' } })).json(); }
    function packEn(c) { return (c.items || []).filter(function (i) { return i.variant_id === d.pack && !(i.properties && i.properties._regalo); }); }
    async function volver(qAntes) {
      try {
        var ls = packEn(await carrito());
        var tot = ls.reduce(function (a, i) { return a + i.quantity; }, 0);
        if (tot > qAntes && ls.length) {
          var l = ls[ls.length - 1];
          await post('/cart/change.js', { id: l.key, quantity: Math.max(0, l.quantity - (tot - qAntes)) });
        }
      } catch (x) {}
    }
    var qAntes = 0;
    try {
      var c0 = await carrito();
      // (auditoría Fable 23-oct) si el cajón quedó viejo (p. ej. volvió con "atrás" desde la caché), no se toca nada: se repinta
      var tu = (c0.items || []).reduce(function (a, i) { return a + ((i.properties && i.properties._regalo) ? 0 : i.quantity); }, 0);
      var faltan = (d.lineas || []).some(function (l) { return !(c0.items || []).some(function (i) { return i.key === l.key; }); });
      if ((typeof d.t === 'number' && tu !== d.t) || faltan) {
        b.textContent = txt; b.classList.remove('is-loading'); b.removeAttribute('aria-busy');
        refrescarCarrito();
        return;
      }
      var ya = packEn(c0);
      qAntes = ya.reduce(function (a, i) { return a + i.quantity; }, 0);
      // (21-oct) _origen: marca oculta de la línea para medir en el pedido cuánto venden «Cámbialo / Agrega … en pack».
      // Si ese pack ya está en el carrito se repiten las propiedades de su línea, para que Shopify sume ahí y no la parta en dos filas.
      var it = { id: d.pack, quantity: d.n };
      // (auditoría Fable 21-oct) nunca fusionar con una línea a S/0 o de AOV: solo se hereda _origen
      var yaOk = ya.filter(function (i) { return i.final_line_price > 0 && !(i.properties && i.properties._aovCampId); });
      if (!yaOk.length) it.properties = { _origen: (d.modo === 'suma' ? 'pack-suma-' : 'pack-cambia-') + (b.closest('#Cart-Drawer, cart-drawer') ? 'cajon' : 'carrito') };
      else if (yaOk[0].properties && yaOk[0].properties._origen) it.properties = { _origen: yaOk[0].properties._origen };
      var r = await post('/cart/add.js', { items: [it] });
      if (!r.ok) { await volver(qAntes); throw new Error('add'); }
      var u = {};
      d.lineas.forEach(function (l) { u[l.key] = l.q; });
      r = await post('/cart/update.js', { updates: u });
      if (!r.ok) { await volver(qAntes); throw new Error('update'); }
      medirPack(b, d);
      var s = st(); s.n = 0; s.t = Date.now();   // el plan siguiente puede ajustar regalos
      refrescarCarrito();
      listoPack();
    } catch (err) {
      b.textContent = suma ? 'No se pudo agregar' : 'No se pudo cambiar';
      setTimeout(function () { b.textContent = txt; b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); }, 2500);
      refrescarCarrito();
    }
  });

  class AlolaRegalos extends HTMLElement {
    connectedCallback() {
      var s = this.querySelector('script[type="application/json"]');
      if (!s) return;
      var plan;
      try { plan = JSON.parse(s.textContent); } catch (e) { return; }
      this.bloquearCantidad(plan.gift_keys || []);
      this.ejecutar(plan);
    }
    bloquearCantidad(keys) {
      // El regalo va siempre en 1 unidad: se esconde el +/- de su línea (el plan igual lo corrige).
      keys.forEach(function (k) {
        document.querySelectorAll('quantity-selector[data-id="' + k + '"]').forEach(function (q) {
          q.querySelectorAll('button').forEach(function (b) { b.style.visibility = 'hidden'; });
          var i = q.querySelector('input'); if (i) { i.readOnly = true; i.style.pointerEvents = 'none'; }
        });
      });
    }
    async ejecutar(plan) {
      var r = await correr(plan);
      if (r.cambio) this.refrescar(r.avisos);
    }
    refrescar(avisos) {
      refrescarCarrito();
      if (avisos.length) this.toast(avisos);
    }
    toast(msgs) {
      var old = document.querySelector('.alola-regalos__toast'); if (old) old.remove();
      var t = document.createElement('div'); t.className = 'alola-regalos__toast'; t.setAttribute('role', 'status');
      msgs.slice(0, 3).forEach(function (m) { var p = document.createElement('p'); p.textContent = m; t.appendChild(p); });
      document.body.appendChild(t);
      setTimeout(function () { t.remove(); }, 6000);
    }
  }
  customElements.define('alola-regalos', AlolaRegalos);
})();
